<template>
  <div class="my_debit" style="margin-top: 0.7rem">
    <div class="my_debit_box">
      <div class="left">
        <leftTemplate :left_tabShow="'my_debit'"></leftTemplate>
      </div>
      <div class="right" style="border-radius: 0.08rem">
        <div class="he">
          <div
            class="div1"
            :class="{ selected: atcIdex == 0 }"
            @click="SetAtcIdex(0)"
          >
            素材发票
          </div>
          <div
            class="div1"
            :class="{ selected: atcIdex == 1 }"
            @click="SetAtcIdex(1)"
          >
            业务发票
          </div>
        </div>
        <el-table
          ref="multipleTableRef"
          :data="tableData"
          v-show="atcIdex == 0"
          style="width: 100%"
          height="430"
        >
          <!-- <el-table-column type="selection" width="55" /> -->
          <el-table-column property="orderNo" width="190" label="订单号" />
          <el-table-column property="title" label="商品名称">
            <template #default="scope">
              <div
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column property="price" label="实付金额" width="100" />
          <el-table-column property="type" label="付款方式" width="100">
            线上支付
          </el-table-column>
          <el-table-column property="createTime" label="下单时间" width="180" />
          <el-table-column property="status" label="开票状态">
            <template #default="scope">
              <el-tag v-if="scope.row.status == 0">未开票</el-tag>
              <el-tag v-if="scope.row.status == 1" type="success"
                >已开票</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column property="invoiceCode" label="发票号">
            <template #default="scope">
              {{ scope.row.invoiceCode ? scope.row.invoiceCode : "/" }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-button
                type="text"
                v-if="scope.row.status == 1"
                @click="openopen(scope.row.pdf)"
                >查看</el-button
              >
              <el-button
                type="info"
                link
                disabled
                v-else-if="scope.row.status == 0"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <template #empty>
            <div style="height: 550px" v-if="tableData.length == 0">
              <div style="width: 90%; margin: 0 auto">
                <img
                  style="width: 100%; margin: 0 auto"
                  src="../../assets/zt_404.png"
                />
              </div>
            </div>
          </template>
        </el-table>
        <el-table
          ref="multipleTableRef"
          :data="tableData"
          v-show="atcIdex == 1"
          style="width: 100%"
          height="430"
        >
          <!-- <el-table-column type="selection" width="55" /> -->
          <el-table-column property="needNo" width="190" label="订单号">
            <template #default="scope">
              <Tooltip :text="scope.row.needNo ? scope.row.needNo : '暂无'">
              </Tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column property="title" label="商品名称">
            <template #default="scope">
              <div
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column property="amount" label="实付金额" />
          <el-table-column property="type" label="付款方式">
            线上支付
          </el-table-column>
          <el-table-column property="payTime" label="下单时间" width="180" />
          <el-table-column property="status" label="开票状态">
            <template #default="scope">
              <el-tag v-if="!scope.row.pdf">未开票</el-tag>
              <el-tag v-else type="success">已开票</el-tag>
            </template>
          </el-table-column>
          <el-table-column property="num" label="发票号">
            <template #default="scope">
              {{ scope.row.num ? scope.row.num : "/" }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-button
                type="text"
                v-if="scope.row.pdf"
                @click="openopen(scope.row.pdf)"
                >查看</el-button
              >
              <el-button type="info" link disabled v-else>查看</el-button>
            </template>
          </el-table-column>
          <template #empty>
            <div style="height: 550px" v-if="tableData.length == 0">
              <div style="width: 90%; margin: 0 auto">
                <img
                  style="width: 100%; margin: 0 auto"
                  src="../../assets/zt_404.png"
                />
              </div>
            </div>
          </template>
        </el-table>
        <!-- 分页 -->
        <div style="display: flex; justify-content: center">
          <el-pagination
            v-if="tableData.length != 0"
            v-model:current-page="page.pageNum"
            v-model:page-size="page.pageSize"
            @size-change="sizeChange"
            @current-change="currentChange"
            style="margin: 0.4rem 0"
            background
            layout="prev, pager, next"
            :total="page.total"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import leftTemplate from "@/components/leftTemplate.vue";
import { ref } from "vue";
import { ElTable, ElMessage } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { useRoute, useRouter } from "vue-router";
import Tooltip from "@/components/Tooltip/index.vue";

const router = useRouter();
const route = useRoute();
document.title = "标识山西-我的发票";
let pageDef = ref({
  pageNum: 1,
  pageSize: 10,
  total: 0,
});
const page = pageDef;
interface User {
  date: string;
  name: string;
  address: string;
  katype: string;
}
const atcIdex = ref(0);
const SetAtcIdex = (index: number) => {
  atcIdex.value = index;
  if (index == 0) {
    init();
  } else {
    init1();
  }
};
const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      // TODO: improvement typing when refactor table
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const totalPay = ref(0.0);
const totalAmount = () => {
  let sum = 0;
  multipleSelection.value.forEach((item) => {
    sum += item.price;
  });

  totalPay.value = sum.toFixed(2);
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
  totalAmount();
};

const tableData = ref([]);
const init = () => {
  Axios(
    "get",
    "/fodder/invoice/my-list",
    {
      pageIndex: page.value.pageNum,
      pageSize: page.value.pageSize,
    },
    false,
    function (res) {
      tableData.value = res.data.rows;
      page.value.total = res.data.total;
    }
  );
};
const init1 = () => {
  Axios(
    "post",
    "/material/material/invoice/my",
    {
      pageIndex: page.value.pageNum,
      pageSize: page.value.pageSize,
    },
    false,
    function (res: any) {
      tableData.value = res.data.data.records;
      page.value.total = res.data.data.total;
    }
  );
};

init();

//全选
const allCheckbox = ref(false);
const selectAll = () => {
  allCheckbox.value = !allCheckbox.value;
  if (allCheckbox.value) {
    tableData.value.forEach((item, index) => {
      multipleTableRef.value!.toggleRowSelection(item, true);
    });
  } else {
    tableData.value.forEach((item, index) => {
      multipleTableRef.value!.toggleRowSelection(item, false);
    });
  }
};
//查看发票
const myDebitView = () => {
  if (
    multipleSelection.value.length > 1 ||
    multipleSelection.value.length == 0
  ) {
    ElMessage({
      message: "只能选择一条数据查看发票",
      type: "warning",
    });

    return;
  }
  router.push({
    path: "/invoiceDebit",
    query: {
      arry: multipleSelection.value[0].id,
      type: "view",
    },
  });
};

/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const nextClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const openopen = (val: string) => {
  val = val.replace(/^http:\/\//i, "https://");
  window.open(val, "_bank");
};
</script>

<style scoped>
@import url(/src/assets/css/left_right.css);

.my_debit_right_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0.2rem 0;
  padding: 0 0.17rem;
  box-sizing: border-box;
  vertical-align: middle;
}

.my_debit {
  background-color: #f5f5f5;
  overflow: hidden;
  width: 100%;
}

.my_debit_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
}

.topBtn {
  font-size: 0.14rem;
  padding: 0.08rem 0.16rem;
  text-align: center;
  color: #333333;
  background: #ffffff;
  border-radius: 0.2rem;
  opacity: 1;
  border: 0.01rem solid #e5e6eb;
  margin-left: 0.2rem;
  cursor: pointer;
}

/deep/ .el-table th.el-table__cell.is-leaf {
  background: #e3e6ec !important;
}

/deep/th .cell .el-checkbox__input {
  display: none;
}

/deep/.el-checkbox.el-checkbox--large {
  height: 0.2rem !important;
}

/* 全选自定义 */
.el-checkbox__inner_zd {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  box-sizing: border-box;
  /* width: var(--el-checkbox-input-width);
			height: var(--el-checkbox-input-height); */
  background-color: #fff;
  z-index: var(--el-index-normal);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    outline 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

.el-checkbox__inner_select::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid transparent;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg) scaleY(0);
  width: 3px;
  transition: transform 0.15s ease-in 50ms;
  transform-origin: center;
  transform: rotate(45deg) scaleY(1);
  border-color: var(--el-checkbox-checked-icon-color);
}

.el-checkbox__inner_select {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  border: 1px solid #c01a26;
  border-radius: 2px;
  box-sizing: border-box;
  color: #fff;
  background-color: #c01a26;
  z-index: var(--el-index-normal);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    outline 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

.he {
  display: flex;
}
.he .div1 {
  padding: 10px 15px;
}
.selected {
  color: #c01a26; /* 选中时的文字颜色 */
}
</style>
